"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isConfirmed = isConfirmed;
exports.isDraft = isDraft;
exports.isNotDraft = isNotDraft;
exports.isReadonlyForAzubi = isReadonlyForAzubi;
exports.isRejected = isRejected;
exports.isSubmitted = isSubmitted;
exports.states = void 0;
var states = exports.states = {
  draft: 'draft',
  submitted: 'submitted',
  rejected: 'rejected',
  confirmed: 'confirmed'
};
function isDraft(status) {
  return status === states.draft;
}
function isReadonlyForAzubi(status) {
  return status === states.submitted || status === states.confirmed;
}
function isNotDraft(status) {
  return status === states.rejected || status === states.confirmed || status === states.submitted;
}
function isSubmitted(status) {
  return status === states.submitted;
}
function isRejected(status) {
  return status === states.rejected;
}
function isConfirmed(status) {
  return status === states.confirmed;
}